import { Injectable } from '@angular/core';

import SelectionEventProvider from '../../../../core/domain/events/selection_event_provider';
import { PatientSelectionEvent } from './patient_selection_event';

@Injectable({ providedIn: 'root' })
export class PatientSelectionEventProvider extends SelectionEventProvider<PatientSelectionEvent> {}
